export default {
  EXPLORE_MORE: "Explore more",
  TITLE_HOME: "Ryspekov | Home",
  TITLE_ABOUT: "Ryspekov | About Me",
  TITLE_CONTACTS: "Ryspekov | Contacts",
  HOME_NAME: "Ryspekov Ansar",
  HOME_SUB: "Programmer | Science lover",
  NAV_HOME: "Home",
  NAV_ABOUT: "About Me",
  NAV_TIMELAPSE: "History",
  NAV_PROJECTS: "Projects",
  NAV_CONTACTS: "Contacts",
  CONTACTS_TITLE: "Get in touch with me",
  CONTACTS_SUB_TITLE: "Response within 24 hours<br />(local time UTC +6.00)",
  about_main_title: "The world needs people capable of solving its problems",
  about_main_subtitle: "Let me be one of them",
  about_soft_title: "Who am I?",
  about_soft_blocks: [
    {
      title: "My name is Ansar",
      text:
        'I come from the beautiful city of Almaty, which literally translates as "Father of Apples". Since childhood, I dreamed of sky and stars, now goals and ideas have been added to these dreams.',
    },
    {
      title: "I'm an Engineer",
      text:
        "While I conquer Computer Science, I like to engage in web development, game development, science and reading books.",
    },
    {
      title: "Red Crescent",
      text:
        "After the tragic death of one wonderful person, I decided to become part of this movement. Such an activity allows me to take a broader look at the situation in the world and how to solve these problems.",
    },
    {
      title: "I think about ecology",
      text:
        "The environmental situation on the planet is very scary, it is necessary to make decisions in this regard. With the small efforts of many, we can prevent a catastrophe.",
    },
  ],
  about_hard_title: "Interested in my technical skills?",
  about_hard_blocks: ["WEB", "Theory", "Experience", "Instruments"],
  about_hard_intro: "What I can do",
  about_hard_intro_blocks: [
    "Create Webpages",
    "Landing Pages",
    "Web Apps",
    "Internet Shops",
    "Responsive, Adaptive Sites",
    "Optimizations",
    "Write Scripts",
    "And More Programming",
  ],
};
